import React, { Component } from 'react';
import { Button, Row, Col } from 'react-bootstrap';
import { MdSubdirectoryArrowLeft, MdKeyboardBackspace, MdClose } from 'react-icons/md';

class TransactionKey extends Component {

    render() {
        const { KeyValue, isMobile, result, OperatorID } = this.props;
        return (
            <>
                <Row className="text-center mt-3">
                    <Col>
                        <Button block variant="danger" id="Reversal" name="Reversal" disabled={((parseInt(result) * 1) === 0 || result === '') || (OperatorID.length !== 4 && OperatorID !== '') ? true : false} onClick={() => this.props.onClick('Reversal')}>
                            {isMobile ? <MdClose /> : KeyValue.Desktop.Reversal}
                        </Button>
                    </Col>
                    <Col>
                        <Button block variant="warning" id="Refund" name="Refund" disabled={((parseInt(result) * 1) === 0 || result === '') || (OperatorID.length !== 4 && OperatorID !== '') ? true : false} onClick={() => this.props.onClick('Refund')}>
                            {isMobile ? <MdKeyboardBackspace /> : KeyValue.Desktop.Refund} </Button>
                    </Col>
                    <Col>
                        <Button block variant="success" id="Purchase" name="Purchase" disabled={((parseInt(result) * 1) === 0 || result === '') || (OperatorID.length !== 4 && OperatorID !== '') ? true : false} onClick={() => this.props.onClick('Purchase')}>
                            {isMobile ? <MdSubdirectoryArrowLeft /> : KeyValue.Desktop.Purchase}</Button>
                    </Col>
                </Row>
            </>
        );
    }
}


export default TransactionKey;
